module.exports = __webpack_public_path__ + "static/20260827_HSE_Q22026_Investor_Presentation_final-15b4d4c511ca0b1de9dcc497886649e4.pdf";